import { FormRows } from '@acorns/web-components'
import ApolloClient from 'apollo-client'

import { RemoteStringsProps } from 'components/HOCs/withRemoteStrings'

export type SuitabilityState = {
  storedQuestions: StoredQuestion[]
  recommendation: string
  coreSuitabilityQuestions: CoreSuitabilityQuestion[]
  showCoreSuitabilityQuestions: boolean
  page: number
  showNextButton: boolean
  existingCoreCustomer: boolean
}

export type CoreSuitabilityAnswer = {
  text: string
  description?: string
  summary: string
  id: string
  key: string
}

export type CoreSuitabilityQuestion = {
  question: {
    text: string
    id: string
    key: string
    possibleAnswers: CoreSuitabilityAnswer[]
  }
}

export enum QuestionFlowType {
  Later = 0,
  Core = 1,
}

export type StoredQuestion = {
  __typename: string
  questionId: string
  answerId?: string
  questionPath?: string // Absence of a path indicates a Core Suitability question
  page: number
  flowType: QuestionFlowType
}

export type InnerProps = {
  client: ApolloClient<any>
  errors: any[]
  headerText: string
  isSubmitting: boolean
  rows: FormRows
  setRows: (rows: any) => void
  showNextButton: boolean
  subheaderText: string
  values: any[]
}

type HandlerProps = {
  handleNextPressed: () => void
  interceptHandleChange: () => void
  interceptSelectHandleChange: (field: string, value: string) => void
}

export type Props = InnerProps & HandlerProps & RemoteStringsProps
